var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentWithClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3137 1H5.06275C3.98524 1 2.95186 1.42804 2.18995 2.18995C1.42804 2.95186 1 3.98524 1 5.06275V37.5647C1 38.6422 1.42804 39.6756 2.18995 40.4375C2.95186 41.1994 3.98524 41.6275 5.06275 41.6275H29.4392C30.5167 41.6275 31.5501 41.1994 32.312 40.4375C33.0739 39.6756 33.502 38.6422 33.502 37.5647V13.1882L21.3137 1Z",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 1V13.1882H33.5007",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.376 23.3447H9.125",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.376 31.4707H9.125",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1877 15.2197H11.1564H9.125",
    stroke: "#E6E6E6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.8463,
    cy: 36.3678,
    r: 12.6314,
    fill: "#111214"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1867 44.6303C38.5614 44.6303 42.1078 41.0839 42.1078 36.7092C42.1078 32.3345 38.5614 28.7881 34.1867 28.7881C29.812 28.7881 26.2656 32.3345 26.2656 36.7092C26.2656 41.0839 29.812 44.6303 34.1867 44.6303Z",
    stroke: "#5779FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1875 31.957V36.7097L37.3559 38.2939",
    stroke: "#5779FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWithClock);
export default __webpack_public_path__ + "static/media/document-with-clock.3a3b3704d36ccfb42fa5425afc87dbe5.svg";
export { ForwardRef as ReactComponent };